export const actionTypes = {
  CLEAR_ALL_WAS_CLICKED: 'CLEAR_ALL_WAS_CLICKED',
  DOCUMENT_WAS_CLICKED_OUTSIDE_OF_OPEN_FILTER: 'DOCUMENT_WAS_CLICKED_OUTSIDE_OF_OPEN_FILTER',
  FILTER_CONTROL_WAS_CLICKED: 'FILTER_CONTROL_WAS_CLICKED',
  FILTER_SEARCH_WAS_CHANGED: 'FILTER_SEARCH_WAS_CHANGED',
  LAST_PROJECTS_URL_WAS_SET: 'LAST_PROJECTS_URL_WAS_SET',
  MAP_WAS_CLICKED: 'MAP_WAS_CLICKED',
  PAGE_HEADER_HEIGHT_WAS_SET: 'PAGE_HEADER_HEIGHT_WAS_SET',
  SORT_CONTROL_WAS_CLICKED: 'SORT_CONTROL_WAS_CLICKED',
  STATE_WAS_RETAINED: 'STATE_WAS_RETAINED',
  VENUE_MARKER_WAS_CLICKED: 'VENUE_MARKER_WAS_CLICKED',
  VENUES_ARE_FETCHING: 'VENUES_ARE_FETCHING',
  VENUES_WERE_FETCHED: 'VENUES_WERE_FETCHED',
  WINDOW_IS_ON_DOWNSWING: 'WINDOW_IS_ON_DOWNSWING',
  WINDOW_IS_ON_UPSWING: 'WINDOW_IS_ON_UPSWING',
  WINDOW_WAS_SCROLLED: 'WINDOW_WAS_SCROLLED',
}
